module.exports = __webpack_public_path__ + "img/gallery-3.6dbe5888.jpg";